import { produce } from 'immer';
import * as types from './engagementToolsTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    records: [],
    totalRecords: 0,
    loading: true,
};

const actionHandlers = {
    [types.GET_ENGAGEMENT_TOOLS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_ENGAGEMENT_TOOLS.SUCCESS]: produce(
        (draft, { total, engagementTools }) => {
            draft.records = engagementTools;
            draft.totalRecords = total;
            draft.loading = false;
        }
    ),
    [types.GET_ENGAGEMENT_TOOLS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_ENGAGEMENT_TOOLS]: produce((draft) => {
        draft.records = [];
        draft.totalRecords = 0;
        draft.loading = true;
    }),
};

export default createReducer(initialState, actionHandlers);
